var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 119,
    viewBox: "0 0 140 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4302_41856)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 21,
    width: 57.4328,
    height: 37,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 20.5,
    width: 58.4328,
    height: 38,
    rx: 8.5,
    stroke: "#D6DCE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.841 31.9022H65.3848V47.0981H73.841V31.9022Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9218 39.5001C65.9204 38.0366 66.2521 36.592 66.8916 35.2757C67.5311 33.9593 68.4617 32.8057 69.6129 31.9021C68.1873 30.7815 66.4751 30.0847 64.6721 29.8911C62.8691 29.6976 61.048 30.0153 59.417 30.8078C57.786 31.6003 56.4109 32.8358 55.4488 34.3729C54.4867 35.91 53.9766 37.6868 53.9766 39.5001C53.9766 41.3135 54.4867 43.0903 55.4488 44.6274C56.4109 46.1645 57.786 47.3999 59.417 48.1924C61.048 48.985 62.8691 49.3026 64.6721 49.1091C66.4751 48.9156 68.1873 48.2187 69.6129 47.0981C68.4617 46.1945 67.5311 45.0409 66.8916 43.7246C66.2521 42.4082 65.9205 40.9636 65.9218 39.5001Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2488 39.5001C85.2489 41.3134 84.7387 43.0902 83.7767 44.6273C82.8147 46.1644 81.4396 47.3999 79.8087 48.1924C78.1777 48.9849 76.3567 49.3026 74.5537 49.1091C72.7507 48.9156 71.0386 48.2187 69.6129 47.0981C70.7632 46.1936 71.693 45.0398 72.3324 43.7237C72.9718 42.4075 73.3041 40.9634 73.3041 39.5001C73.3041 38.0369 72.9718 36.5927 72.3324 35.2766C71.693 33.9604 70.7632 32.8066 69.6129 31.9021C71.0386 30.7815 72.7507 30.0846 74.5537 29.8911C76.3567 29.6976 78.1777 30.0153 79.8087 30.8078C81.4396 31.6004 82.8147 32.8358 83.7767 34.3729C84.7387 35.91 85.2489 37.6868 85.2488 39.5001Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3268 45.4886V45.1775H84.4522V45.1141H84.1328V45.1775H84.2583V45.4886H84.3268ZM84.947 45.4886V45.1135H84.8491L84.7365 45.3715L84.6238 45.1135H84.5258V45.4886H84.595V45.2057L84.7006 45.4496H84.7723L84.8779 45.205V45.4886H84.947Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4302_41856",
    x: 0,
    y: 0,
    width: 139.43,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4302_41856"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4302_41856",
    result: "effect2_dropShadow_4302_41856"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4302_41856",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.fa42100250715578a07f3c7433bfc7ed.svg";
export { ForwardRef as ReactComponent };